var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{attrs:{"text":_vm.$t('blind_transfer'),"position":"bottom"}},[_c('vs-button',{staticClass:"includeIcon includeIconOnly",attrs:{"color":"success","type":"border"},on:{"click":_vm.process}},[_c('i',{staticClass:"c-icon-blind-transfer"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }